import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { getConsent, setConsent } from "../utils/consent";
import { Button, Grid, Link, Typography} from '@mui/material';

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "16px",
    background: "rgba(42, 42, 42, 1)",
    color: "#fff",
    zIndex: 1000,
    width: "50%",
    height: "auto",
    borderRadius: "16px",
  },
  buttons: {
    display: "flex",
    gap: "8px",
    marginTop: "10px",
  },
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent("accepted");
    setVisible(false);
    window.location.reload(); // easiest way to re-run tracking logic
  };

  const reject = () => {
    setConsent("rejected");
    setVisible(false);
  };

  return (
    <div style={styles.banner}>
    <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
            <Typography variant="p" style={{ margin: '16px 0', fontSize: '15px' }}>
                We use cookies for analytics and user experience tracking, to deliver the best experience to you.
                You can read more about our use in the <Link component={RouterLink} to="/cookie-policy" style={{ fontWeight: 'bold', color: 'white', textDecoration: 'underline' }}>Cookie Policy</Link>.
            </Typography>
        </Grid>

        <Grid item xs={12} sm={2} style={styles.buttons}>
            <Button variant="contained" color="primary" onClick={accept}>Dismiss</Button>
        </Grid>
      </Grid>
    </div>
  );
}


